import { connect } from 'react-redux';
import { getFormValues , reduxForm} from 'redux-form';
import React, {Component} from 'react';
import Grid from '@react/react-spectrum/Grid/js/Grid';
import GridColumn from '@react/react-spectrum/Grid/js/GridColumn';
import GridRow from '@react/react-spectrum/Grid/js/GridRow';
import DataSection from '../../comps/DataSection/DataSection';
import formFields from '../config/formFields';
import Heading from '@react/react-spectrum/Heading/js/Heading';
import { Translate } from 'react-redux-i18n';
import { getContacts } from '../utils/utils';


class RenewalCriteria extends Component{ 
    constructor(props)
    {
        super(props);
        window.scrollTo(0,0);
        this.state = {
            sectionValidation : {}
        };
        this.maxPageSize = 10
    }

    componentDidMount() {
        // THIS TO BE UNCOMMENTED AND VALUE TO BE UPDATED TO TRUE AND USE IN remove LOADING
        //this.props.onUpdateContactUploadStatus(false);
        this.props.connector.fetchContacts(this.onFetchComplete, this.props.partnerData.partnerInfo.accountId, { "page": 0, "size": this.maxPageSize });
    }

    onFetchComplete = (responseData) => {
        let initialFormStates = this.props.formStates;
        let contacts;
        let initFields = {};
        if (!responseData.isError && responseData.contacts) {
            contacts = getContacts(responseData.contacts, responseData.cocStatus);
            // console.log('contacts are present');
            Object.keys(initialFormStates).map(ele => {
            if(ele.startsWith("contactId_") || ele.startsWith("prefix_") || ele.startsWith("suffix_") || ele.startsWith("firstName_") || ele.startsWith("lastName_") || ele.startsWith("mainContactType_") || ele.startsWith("active_") || ele.startsWith("certification_") || ele.startsWith("phone_") || ele.startsWith("email_") || ele.startsWith("jobRole_") || ele.startsWith("preferredLanguage_") || ele.startsWith("additionalContactType_") ){
                initialFormStates[ele] = null ; 
            }
            });
            initFields = { ...initialFormStates,...contacts.retObj, contacts_loaded: true, contact_suffix: contacts.contact_suffix, noOfContacts: responseData.noOfContacts ?  responseData.noOfContacts : this.state.noOfContacts, cocStatus: responseData.cocStatus, hasCoc : (responseData.hasCoc ? responseData.hasCoc : false)};
            this.props.initialize(initFields);
            this.setState({ contact_suffix: contacts.contact_suffix,
            noOfContacts: responseData.noOfContacts ?  responseData.noOfContacts : this.state.noOfContacts,
            cocStatus: responseData.cocStatus});
            // console.log('contacts were present');
            }
        else {
            if(contacts != undefined && Boolean(contacts.contact_suffix)) {
                this.setState({ contact_suffix: contacts.contact_suffix });
            }
            let initialFormStates = this.props.formStates;
            initFields = { ...initialFormStates, contacts_loaded: true};
            this.props.initialize(initFields);
        }
    }



    updateValidation = (name,value) => {
        let sectionValidation = this.state.sectionValidation;
        sectionValidation[name] = value;
        this.setState({sectionValidation:sectionValidation});
    }

    fetchCriteria = () => {
        if (this.props.formStates.partnerProgramType == "Retail Partner") {
            return <>
                <li>Retail partner must meet all of the criteria for the desired level. See the Adobe Partner Connection Retail Program Guide for a complete list of requirements.</li>
                <li>Retail partner must complete this online enrollment and accept the Retail Program terms and conditions.</li>
            </>;
        }
        if (this.props.formStates.level == "Registered") {
            return <>
                <li> <Translate value="registration.reg_ctr_text1"/> </li>
                <li> <Translate value="registration.reg_ctr_text2"/> </li>
            </>;
        }
        if (this.props.formStates.level == "Certified") {
            return <>
                <li> <Translate value="uplevelRenewal.ctr1_certified"/> </li>
                <li> <Translate value="uplevelRenewal.ctr2_certified"/> </li>
            </>;
        }
        return <>
            <li><Translate value="uplevelRenewal.ctr1_gold"/> </li>
            <li><Translate value="uplevelRenewal.ctr2_gold"/></li>
        </>;
    }

    render(){
        this.props.onValidateChange(Object.values(this.state.sectionValidation).every(Boolean));
        const formName = 'uplevelRenewal';
        return <div>
            <Grid>
                <GridRow >
                    <GridColumn size={[12,10,8,8]} offsetSize={[0,1,2,2]}>
                    <Heading className = "textBold" variant="pageTitle"><Translate value="uplevelRenewal.OnbrdCriteriaHeaderRenewal" /></Heading>
                    <p><Translate value="uplevelRenewal.OnbrdCriteriaBodyRenewal" /></p>
                    <p><Translate value="uplevelRenewal.OnbrdCriteriaBody1" dangerousHTML/></p>
                    <Translate value="uplevelRenewal.OnbrdCriteriaHeaderRenewal" />
                    <GridRow className="textBox">
                        <GridColumn>
                        <ul>
                            {this.fetchCriteria()}
                        </ul>
                        </GridColumn>
                    </GridRow>
                    <GridRow>
                        <GridColumn>
                        <DataSection formStates={this.props.formStates} form={formName} field={formFields.section2} sectionName="section2" updateValidation={this.updateValidation}/>
                        <ul>
                            <li><Translate value="uplevelRenewal.OnbrdCriteriaAuthorized" /></li>
                            <li><Translate value="uplevelRenewal.OnbrdCriteriaAuthorized2" /></li>
                        </ul>
                        </GridColumn>
                    </GridRow>
                    </GridColumn>
                </GridRow>
            </Grid>
        </div>;
    }
}
RenewalCriteria = reduxForm({
    form:'uplevelRenewal',
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(RenewalCriteria);

function mapStateToProps(state) {
    return {
        formStates: getFormValues('uplevelRenewal')(state) // here 'form' is the name you have given your redux form  
    }
}

export default connect(mapStateToProps)(RenewalCriteria);